import React from 'react';
import type { AllEntities, AnEntity } from 'c-sdk';
import type { PageEntityConfig } from 'c-config';

export type UseEntityPageContextValues = {
    entityName?: keyof AllEntities;
    // null outside an entity page (the default) and in tests that only need the entity name
    pageConfig: PageEntityConfig<AnEntity> | null;
};

export const UseEntityPageContext = React.createContext<UseEntityPageContextValues>({
    entityName: undefined,
    pageConfig: null,
});
